// The full Price Identifier Code list (DE 236) — shared by CTP02 across
// transaction sets. It is the union of the previous hand-picked CTP02
// subset (header-segments.ts) and the 855-specific CTP02 list in
// reference/session/855-purchase-order-acknowledgment-qualifiers-txt.md, and
// is the canonical list going forward.

import type {CodeListEntry} from './types';

export const PRICE_IDENTIFIER_CODES: CodeListEntry[] = [
  {code: 'PAR', label: 'Base Price'},
  {code: 'NOM', label: 'List/Nominal Price'},
  {code: 'CUP', label: 'Confirmed Unit Price'},
  {code: 'CHG', label: 'Changed Price'},
  {code: 'CON', label: 'Contract Price'},
  {code: 'CAT', label: 'Catalog Price'},
  {code: 'LPR', label: 'List Price'},
  {code: 'DIS', label: "Distributor's Price"},
  {code: 'DPR', label: 'Discount Price'},
  {code: 'MSR', label: "Manufacturer's Suggested Retail"},
  {code: 'INV', label: 'Invoice Billing Price'},
  {code: 'C01', label: 'Contract Tier 1'},
  {code: 'C02', label: 'Contract Tier 2'},
  {code: 'C03', label: 'Contract Tier 3'},
  {code: 'C04', label: 'Contract Tier 4'},
  {code: 'C05', label: 'Contract Tier 5'},
  {code: 'C06', label: 'Contract Tier 6'},
  {code: 'C07', label: 'Contract Tier 7'},
  {code: 'C08', label: 'Contract Tier 8'},
  {code: 'C09', label: 'Contract Tier 9'},
  {code: 'C10', label: 'Contract Tier 10'},
  {code: 'C11', label: 'Contract Tier 11'},
  {code: 'C12', label: 'Contract Tier 12'},
  {code: 'C13', label: 'Contract Tier 13'},
  {code: 'C14', label: 'Contract Tier 14'},
  {code: 'C15', label: 'Contract Tier 15'},
  {code: 'C16', label: 'Contract Tier 16'},
  {code: 'C17', label: 'Contract Tier 17'},
  {code: 'C18', label: 'Contract Tier 18'},
  {code: 'C19', label: 'Contract Tier 19'},
  {code: 'C20', label: 'Contract Tier 20'},
  {code: 'C21', label: 'Contract Tier 21'},
  {code: 'C22', label: 'Contract Tier 22'},
  {code: 'C23', label: 'Contract Tier 23'},
  {code: 'C24', label: 'Contract Tier 24'},
  {code: 'C25', label: 'Contract Tier 25'},
  {code: 'C26', label: 'Contract Tier 26'},
  {code: 'C27', label: 'Contract Tier 27'},
  {code: 'C28', label: 'Contract Tier 28'},
  {code: 'C29', label: 'Contract Tier 29'},
  {code: 'C30', label: 'Contract Tier 30'},
];
